﻿import { OrganType } from '@nkr/enums/organ-type';
import { IListItem } from './list-item';

export interface IContactEntityTypePositions {
    entityTypeId: number;
    entityType: string;
    organType: OrganType;
    positions: IListItem[];
}
